<template>
    <font-awesome-icon v-if="isStatusConfigured" :icon="icon" :class="`text-${variant}`"/>
</template>

<script>
export default {
    name: "RefundRequestIcon",

    props: {
        status: {required: true, type: String},
    },

    computed: {
        isStatusConfigured() {
            return !!REFUND_REQUEST_ICONS[this.status]
        },
        icon() {
            return REFUND_REQUEST_ICONS[this.status].icon
        },
        variant() {
            return REFUND_REQUEST_ICONS[this.status].variant
        },
    },
}

const REFUND_REQUEST_ICONS = {
    'created-by-oms': {
        icon: 'star-of-life',
        variant: 'info',
    },
    'created-by-external-party': {
        icon: 'star-of-life',
        variant: 'info',
    },
    'proposal': {
        icon: 'question-circle',
        variant: 'primary',
    },
    'proposal-to-be-released-automatically': {
        icon: 'clock',
        variant: 'primary',
    },
    'decision-denied-final': {
        icon: 'stop-circle',
        variant: 'danger',
    },
    'decision-approved-final': {
        icon: 'play-circle',
        variant: 'success',
    },
    'refund-to-be-processed': {
        icon: 'dot-circle',
        variant: 'secondary',
    },
    'refund-processing': {
        icon: 'dot-circle',
        variant: 'success',
    },
    'refund-to-be-processed-manually': {
        icon: 'pause-circle',
        variant: 'info',
    },
    'refund-processing-manually': {
        icon: 'lock',
        variant: 'info',
    },
    'refund-error': {
        icon: 'times-circle',
        variant: 'danger',
    },
    'processed': {
        icon: 'check-circle',
        variant: 'refunded',
    },
}
</script>

<style scoped>

</style>
